import '@/assets/loadAuthComponents';

import { CMSProviderClient } from '@dfl/react-cms-client';
import { Layout } from 'antd';
import classNames from 'classnames';
import React, { memo, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import Footer from '@/components/Footer';
import PageLoader from '@/components/PageLoader';
import MainHeader from '@/layout/MainHeader';
import { useSettings } from '@/modules/configuration/hooks/useSettings';
import HomeModule from '@/modules/home';
import style from '@/modules/home/index.less';

const { Content, Header } = Layout;

const UnauthenticatedLayout = () => {
  const { pathname } = useLocation();
  const { data: configurations } = useSettings();
  const isHome = pathname === '/';
  
  return (
    <CMSProviderClient>
      <Suspense fallback={<PageLoader/>}>
        <Header className={classNames(style.header, { [style.homeHeader]: isHome })} id={'main-header'}>
          <MainHeader isCenter inverse={isHome}/>
        </Header>
        <Content className={classNames('wrapper-main-content', { [style.mainLayout]: configurations?.inMaintenance })}>
          <HomeModule/>
        </Content>
        <Footer/>
      </Suspense>
    </CMSProviderClient>);
};

UnauthenticatedLayout.propTypes = {};

UnauthenticatedLayout.defaultProps = {};

export default memo(UnauthenticatedLayout);
